import { encodeBase64, decodeBase64 } from '../function/stringHelpers';

interface FileReference {
    FileName: string;
    FileType: string;
    FileRef: string;
}

document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('priceCalculatorForm');
    const resultOutput = document.getElementById('resultOutput');
    const attachmentErrorOutput = document.getElementById('attachmentErrorOutput');
    const quoteRequestErrorOutput = document.getElementById('quoteRequestErrorOutput');
    const quoteInvalidSessionError = document.getElementById('quoteInvalidSessionError');
    const priceCalcluatorparent = document.getElementById('calculatorParent');
    const loader = document.getElementById('loader');
    const priceResult = document.getElementById('priceResult');
    const neutralResult = document.getElementById('neutralResult');
    const negativeResult = document.getElementById('negativeResult');
    const negativeResultText = document.getElementById('negativeResultText') as HTMLInputElement;
    const nextButton = document.getElementById('nextButton');
    const nextContainer = document.getElementById('nextContainer');
    const calculatorContent = document.querySelector('.calculatorContent');
    const furtherInputFields = document.getElementById('furtherInputFields');
    const submitButton = document.getElementById('submitFormButton') as HTMLButtonElement;
    const submitAttachment = document.getElementById('submitAttachment') as HTMLInputElement;
    const description = document.getElementById('description') as HTMLInputElement;
    const receipt = document.getElementById('receiptParent');
    const consentCheckbox = document.getElementById('consentCheckbox') as HTMLInputElement;
    const m2 = document.getElementById("m2") as HTMLInputElement;
    const gate = document.getElementById("gate") as HTMLInputElement;
    const gateNummer = document.getElementById("gateNummer") as HTMLInputElement;
    const postnr = document.getElementById("postnr") as HTMLInputElement;
    const poststed = document.getElementById("poststed") as HTMLInputElement;
    const recalculateLink = document.getElementById("recalculateLink") as HTMLAnchorElement;
    const addressList = document.getElementById("addressList");
    const streetNumberList = document.getElementById("streetNumberList");
    const resultWho = document.getElementById('resultWho');
    const resultM2 = document.getElementById('resultM2');
    const summaryValue = document.getElementById('summaryValue');
    const resultGate = document.getElementById('resultGate');
    const resultPostnr = document.getElementById('resultPostnr');
    const resultPoststed = document.getElementById('resultPoststed');
    const firstName = document.getElementById('firstName') as HTMLInputElement;
    const firstNameError = document.getElementById('errorName') as HTMLInputElement;
    const email = document.getElementById('email') as HTMLInputElement;
    const emailError = document.getElementById('errorEmail') as HTMLInputElement;
    const errorOrgName = document.getElementById('errorOrgName') as HTMLInputElement;
    const errorOrgNumber = document.getElementById('errorOrgNumber') as HTMLInputElement;
    const phoneNumber = document.getElementById('phonenumber') as HTMLInputElement;
    const phoneNumberError = document.getElementById('errorPhonenumber') as HTMLInputElement;
    const orgNumberContainer = document.getElementById("orgNumberContainer");
    const orgNumber = document.getElementById("orgNumber") as HTMLInputElement;
    const orgNameContainer = document.getElementById("orgNameContainer");
    const orgName = document.getElementById("orgName") as HTMLInputElement;
    const inkNokElement = document.getElementById("inkNok");
    const addressLookupUrl = document.getElementById('addressLookupUrl') as HTMLInputElement;
    const priceCalculatorUrl = document.getElementById('priceCalculatorUrl') as HTMLInputElement;
    const quoteRequestUrl = document.getElementById('quoteRequestUrl') as HTMLInputElement;
    const uploadAttachmentUrl = document.getElementById('uploadAttachmentUrl') as HTMLInputElement;
    const veidekkeSessionUrl = document.getElementById('veidekkeSessionUrl') as HTMLInputElement;
    const firstPartResult = document.getElementById('firstPartResult') as HTMLInputElement;
    const inkNok = document.getElementById('inkNok') as HTMLInputElement;
    const asphaltCalculator = document.getElementById('asphaltCalculator') as HTMLInputElement;
    const fullNameLabelText = document.getElementById('fullNameLabelText') as HTMLLabelElement;
    const signicatErrorContainer = document.getElementById('signicatErrorContainer') as HTMLLabelElement;
    const signicatErrorResponse = document.getElementById('signicatErrorResponse') as HTMLLabelElement;
    const attachmentList = document.getElementById("attachmentList");
    const companyString = "Company";
    const unableString = "Unable";
    const headerBring = "bring";
    const headerSignicat = "signicat";
    var signicatCallbackUrl = window.location.href + "?m2";
    var decodedParams = new URLSearchParams();
    var estimatedPrice = unableString;
    var signicatAuthUrl;
    var fileReferences = <FileReference[]>[];
    var filteredAddresses = Array<any>();
    var validNumbers = Array<any>();
    var fileUploadFailed = false;
    var gateClicked = false;
    var gateNummerClicked = false
    var streetId;
    var gateAdresse;
    var uploadedFiles: File[] = [];
    var priceCalculatorQueryString;
    var addressLookupQueryString;

    if (!form || !receipt || !resultOutput || !submitButton || !nextContainer || !priceCalcluatorparent || !priceResult || !negativeResult || !neutralResult || !nextButton || !calculatorContent || !furtherInputFields || !consentCheckbox) {
        return;
    }

    toggleButton();

    function debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    async function getToken(service: string) {
        try {
            const response = await fetch(`/api/token/getToken/${service}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return await response.text();
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching token:', error);
            return null;
        }
    }

    async function getHeaders(tokenType: string, method: string) {
        const token = await getToken(tokenType);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);

        return {
            method: method,
            headers: myHeaders,
        };
    }

    async function fetchAddresses() {
        const requestOptions = await getHeaders(headerBring, "GET");
        const url = `${addressLookupUrl.value + 'suggestions/?q=' + gate.value}`;

        if (addressLookupQueryString != url) {
            try {
                gateClicked = false;
                const response = await fetch(url, requestOptions);
                addressLookupQueryString = url;
                const data = await response.json();
                const validAddresses: Array<any> = data.streets_and_places.map((street: any) => street);

                resetAddresses();
                gateNummer.value = "";
                gateNummer.disabled = true;
                poststed.value = "";
                postnr.value = "";

                var nextPage = data.navigation.next;
                while (nextPage) {
                    const response = await fetch(`${addressLookupUrl.value + nextPage.split('/no/')[1]}`, requestOptions);
                    const data = await response.json();
                    const nextAddresses: Array<any> = data.streets_and_places.map((street: any) => street)
                    validAddresses.push(...nextAddresses)
                    nextPage = data.navigation.next;
                }

                filteredAddresses = validAddresses.filter((address, index, self) =>
                    index === self.findIndex((t) => t.id === address.id)
                );

                filteredAddresses.forEach((street) => {
                    const listItem = document.createElement("li");
                    listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
                    listItem.innerHTML = '<b>' + street.name + " " + '</b>' + "     " + " " + street.city.toUpperCase();

                    listItem.onmousedown = function () {
                        streetId = street.id;
                        gateNummer.disabled = false;
                        gateClicked = true;
                        fetchStreetNumbers();
                        gate.value = street.name;
                        resetAddresses();
                    };
                    addressList.appendChild(listItem);
                });
            } catch (error) {
                // ToDo: do something with the error
                console.error('Error fetching data:', error);
            }
        }
    }

    const focusGate = async () => {
        if (gate !== undefined && gate.value !== "") {
            await fetchAddresses();
            await updateResult();
        }
    }

    const selectAddress = async () => {
        if (filteredAddresses !== undefined && filteredAddresses.length > 0 && gate.value !== "" && !gateClicked) {
            const street = filteredAddresses[0];
            const listItem = document.createElement("li");
            listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
            listItem.innerHTML = '<b>' + street.name + " " + '</b>' + "     " + " " + street.city.toUpperCase();

            streetId = street.id;
            gateNummer.disabled = false;
            fetchStreetNumbers();
            gate.value = street.name;

            addressList.appendChild(listItem);
            resetAddresses();
        }
    }

    async function fetchStreetNumbers() {
        const requestOptions = await getHeaders(headerBring, "GET");

        try {
            gateNummerClicked = false;
            const response = await fetch(`${addressLookupUrl.value + 'streets/' + streetId + '/numbers'}`, requestOptions);
            const data = await response.json();
            validNumbers = data.street_numbers.map((number: any) => number)
            var nextPage = data.navigation.next;

            while (nextPage) {
                const response = await fetch(`${addressLookupUrl.value + nextPage.split('/no/')[1]}`, requestOptions);
                const data = await response.json();
                const nextNumbers: Array<any> = data.street_numbers.map((number: any) => number)
                validNumbers.push(...nextNumbers)
                nextPage = data.navigation.next;
            }

            if (gateNummer.value) {
                validNumbers = validNumbers.filter(number => number.formatted_number.startsWith(gateNummer.value));
            }

            streetNumberList.innerHTML = "";

            validNumbers.forEach((number) => {
                const listItem = document.createElement("li");
                listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
                listItem.innerHTML = '<b>' + number.formatted_number + '</b>';

                listItem.onmousedown = function () {
                    gateNummerClicked = true;
                    gateNummer.value = number.formatted_number;
                    gateAdresse = gate.value + " " + number.formatted_number;
                    streetNumberList.innerHTML = "";
                    updatePostnr(number.address_id);
                };
                streetNumberList.appendChild(listItem);
            });
            gateNummer.focus();
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }

    const selectGatenummer = async () => {
        if (validNumbers !== undefined && validNumbers.length > 0 && !gateNummerClicked) {
            const number = validNumbers[0];
            const listItem = document.createElement("li");
            listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
            listItem.innerHTML = '<b>' + number.formatted_number + '</b>';

            gateNummer.value = number.formatted_number;
            gateAdresse = gate.value + " " + number.formatted_number;
            updatePostnr(number.address_id);

            streetNumberList.appendChild(listItem);
            resetStreetnumbers();
        }
    }

    async function updatePostnr(addressId: string) {
        const requestOptions = await getHeaders(headerBring, "GET");
        try {
            const response = await fetch(`${addressLookupUrl.value + 'addresses/' + addressId}`, requestOptions);
            const data = await response.json();
            postnr.value = data.postal_code;
            poststed.value = data.city;
            updateResult();
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }

    const resetAddresses = () => {
        addressList.innerHTML = "";
    }

    const resetStreetnumbers = () => {
        streetNumberList.innerHTML = "";
    }

    const getSignicatAuthUrl = async () => {
        const token = await getToken("signicat");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        let privateOrCompany = (form.querySelector('input[name="options"]:checked') as HTMLInputElement).value;

        if (!privateOrCompany) {
            privateOrCompany = "Private";
        }

        let successCallback = `${signicatCallbackUrl + "=" + m2.value}&who=${privateOrCompany}&gate=${gateAdresse}&postnr=${postnr.value}&poststed=${poststed.value}&estimat=${estimatedPrice}`;
        const baseUrl = successCallback.split('?')[0];
        const queryString = successCallback.split('?')[1];
        const abortCallback = baseUrl + "?" + encodeBase64("abort");
        const errorCallback = baseUrl + "?" + encodeBase64("error");
        successCallback = baseUrl + "?" + encodeBase64(queryString);

        const data = {
            allowedProviders: ["sms-otp"],
            "language": "no",
            flow: "redirect",
            requestedAttributes: [
                "idpId",
                "name"
            ],
            callbackUrls: {
                success: successCallback,
                abort: abortCallback,
                error: errorCallback
            }
        }

        const jsonData = JSON.stringify(data);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: jsonData
        };

        try {
            const response = await fetch(veidekkeSessionUrl.value, requestOptions);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            signicatAuthUrl = data.authenticationUrl;
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }

    function decodeParams() {
        const queryString = window.location.href.split('?')[1];
        const relQueryString = queryString.split('&sessionId')[0];
        const decodedQueryString = decodeBase64(relQueryString);

        decodedParams = new URLSearchParams(decodedQueryString);
    }

    const updateSummary = () => {
        if (decodedParams.get('who') === companyString) {
            resultWho.textContent = "Bedrift";
            orgNameContainer.style.display = 'flex';
            orgNumberContainer.style.display = "flex";
            fullNameLabelText.innerHTML = "Kontaktperson – Fullt navn​";
        } else {
            resultWho.textContent = "Privat";
            orgNameContainer.style.display = 'none';
            orgNumberContainer.style.display = "none";
            fullNameLabelText.innerHTML = "Fullt navn​";
        }

        resultM2.textContent = decodedParams.get('m2');;
        const estimate = decodedParams.get('estimat');

        if (estimate === unableString) {
            inkNokElement.textContent = "Automatisk pris ikke gitt";
        } else {
            if (estimate) {
                summaryValue.textContent = formatNumberWithSpaces(estimate) + " NOK";
            }
            decodedParams.get('who') === companyString
                ? inkNok.textContent = "Ekskl Mva"
                : inkNok.textContent = "Inkl Mva";
        }

        resultGate.textContent = decodedParams.get('gate');
        resultPostnr.textContent = decodedParams.get('postnr');
        resultPoststed.textContent = decodedParams.get('poststed');
    };

    const getSession = async () => {
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get('sessionId');

        if (!sessionId) {
            return false;
        }

        try {
            const requestOptions = await getHeaders(headerSignicat, "GET");
            const response = await fetch(`${veidekkeSessionUrl.value}${sessionId}`, requestOptions)

            return response;
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }

    const checkSession = async () => {
        const session = await getSession();
        if (session) {
            decodeParams();
            if (decodedParams.has('abort')) {
                var newURL = window.location.href.split('?')[0]
                signicatCallbackUrl = newURL + "?m2";
                window.history.pushState({}, null, newURL);
            } else if (decodedParams.has('error')) {
                var data = await session.json();
                signicatErrorContainer.style.display = "block";
                signicatErrorResponse.innerHTML = data.status + " " + data.title;
            }
            else {
                furtherInputFields.style.display = 'block';
                priceCalcluatorparent.style.display = 'none';
                updateSummary();
            }
        }
        asphaltCalculator.scrollIntoView({ behavior: 'auto' });
    }

    checkSession();

    m2.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
    });
    m2.addEventListener('wheel', (event: WheelEvent) => {
        event.preventDefault();
    });
    phoneNumber.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
    });
    phoneNumber.addEventListener('wheel', (event: WheelEvent) => {
        event.preventDefault();
    });

    function formatNumberWithSpaces(input: number | string): string {
        const numStr = input.toString();
        const formattedNumber = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        return formattedNumber;
    }

    const updateResult = async () => {
        let allFieldsFilled = m2.value && gate.value && gateNummer.value && postnr.value && poststed.value;

        if (allFieldsFilled && postnr.value.length === 4 && /^\d{4}$/.test(postnr.value)) {
            const url = `${priceCalculatorUrl.value}?m2=${m2.value}&street=${gateAdresse}&postalcode=${postnr.value}`;

            if (priceCalculatorQueryString != url) {
                try {
                    loader.style.display = "block";
                    const requestOptions = await getHeaders("dynamics", "GET");
                    const response = await fetch(url, requestOptions)

                    if (response.ok) {
                        priceCalculatorQueryString = url;
                        const data = await response.json();
                        if (data.message === "ok") {
                            let privateOrCompany = (form.querySelector('input[name="options"]:checked') as HTMLInputElement).value;

                            if (privateOrCompany && privateOrCompany === companyString) {
                                const priceWithoutDecimals = Math.floor(data.price);
                                estimatedPrice = priceWithoutDecimals.toString();
                                const priceWithNok = formatNumberWithSpaces(priceWithoutDecimals) + " NOK";
                                firstPartResult.textContent = "Prisestimat Ekskl mva"
                                resultOutput.textContent = priceWithNok;
                            }
                            else {
                                const withMva = (data.price * 1.25);
                                const priceWithoutDecimals = Math.floor(withMva);
                                estimatedPrice = priceWithoutDecimals.toString();
                                const priceWithNok = formatNumberWithSpaces(priceWithoutDecimals) + " NOK";
                                firstPartResult.textContent = "Prisestimat Inkl mva"
                                resultOutput.textContent = priceWithNok;
                            }

                            negativeResult.style.display = "none"
                            priceResult.style.display = 'block';
                            nextContainer.style.display = 'block'
                            nextButton.focus({ preventScroll: true });
                            neutralResult.style.display = 'none';
                        } else if (data.message === "Ta kontakt for pris" || data.message === "error") { //ikke noe estimat men fremdeles mulighet til å sende inn
                            resultOutput.textContent = '';
                            priceResult.style.display = 'none';
                            neutralResult.style.display = 'block';
                            nextContainer.style.display = 'block'
                            nextButton.focus({ preventScroll: true });
                            negativeResult.style.display = "none"
                            estimatedPrice = unableString;
                        }
                        else if (data.message === "Vi leverer ikke i ditt område") { // ikke noe eastimat eller mulighet til å sende inn
                            negativeResult.style.display = "block"
                            nextContainer.style.display = 'none'
                            priceResult.style.display = 'none';
                            neutralResult.style.display = 'none';
                            estimatedPrice = unableString;
                        }
                        else {
                            estimatedPrice = unableString;
                            // ToDo: do something with the error
                            console.log("error")
                        }
                    }
                    else {
                        throw new Error(await response.statusText);
                    }
                } catch (error) {
                    // ToDo: do something with the error
                    console.error('Error fetching price:', error);
                    priceResult.style.display = 'none';
                    negativeResult.style.display = 'block';
                    negativeResultText.innerHTML = error;
                    estimatedPrice = unableString;
                }
                getSignicatAuthUrl();
            }
        } else {
            resultOutput.textContent = '';
            priceResult.style.display = 'none';
            neutralResult.style.display = 'none';
            nextContainer.style.display = 'none';
            negativeResult.style.display = "none";
        }
        loader.style.display = "none";
    };
    function toggleButton() {
        submitButton.disabled = !consentCheckbox.checked;
        submitButton.disabled
            ? submitButton.classList.add('disabled')
            : submitButton.classList.remove('disabled');
    }

    consentCheckbox.addEventListener('change', toggleButton);

    function isEmailOk(emailValue: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailValue.trim());
    }

    function isPhonenumberOk(number: string): boolean {
        // Remove any non-digit characters
        const cleanedNumber = number.replace(/\D/g, '');
        return cleanedNumber.length === 8;
    }

    const validateForm: () => Promise<boolean> = async (): Promise<boolean> => {
        const fullName = firstName.value.trim().split(" ");
        const hasFirstName = fullName[0] && fullName[0].length > 0;
        const hasLastName = fullName[1] && fullName[1].length > 0;
        const isEmailValid = isEmailOk(email.value.toString())
        const isPhoneNumberValid = isPhonenumberOk(phoneNumber.value)
        const isConsentChecked = consentCheckbox.checked;
        let requiredFieldsFilled = hasFirstName && hasLastName && isEmailValid && isPhoneNumberValid && isConsentChecked;
        const sessionResponse = await getSession();

        if (sessionResponse && !sessionResponse.ok && sessionResponse.status !== 200) {
            quoteInvalidSessionError.style.display = "block";
            requiredFieldsFilled = false;
        }

        if (!hasFirstName || !hasLastName) {
            firstNameError.style.display = "block"
        }

        if (!isEmailValid) {
            emailError.style.display = "block"
        }

        if (decodedParams.get('who') === companyString) {
            if (orgName.value === "") {
                errorOrgName.style.display = "block";
                requiredFieldsFilled = false;
            }

            if (orgNumber.value === "") {
                errorOrgNumber.style.display = "block";
                requiredFieldsFilled = false;
            }
        }

        if (!isPhoneNumberValid) {
            phoneNumberError.style.display = "block"
        }

        return requiredFieldsFilled
    };

    gate.addEventListener("input", debounce(() => fetchAddresses()));
    gate.addEventListener("focus", focusGate);
    gate.addEventListener("focusout", resetAddresses);
    gate.addEventListener("blur", selectAddress);
    gate.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
            selectAddress();
        }
    });

    gateNummer.addEventListener("input", debounce(() => fetchStreetNumbers()));
    gateNummer.addEventListener("focus", debounce(() => fetchStreetNumbers()));
    gateNummer.addEventListener("blur", selectGatenummer);
    gateNummer.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
            selectGatenummer();
        }
    });

    m2.addEventListener('input', debounce(() => updateResult()));
    m2.addEventListener('change', debounce(() => updateResult()));

    orgNumber.addEventListener('input', debounce(() => updateResult()));
    orgNumber.addEventListener('change', debounce(() => updateResult()));

    form.querySelectorAll('input[name="options"]').forEach((radio) => {
        radio.addEventListener('change', (event) => {
            debounce(() => updateResult())();
        });
    });

    nextButton.addEventListener('click', () => {
        window.location.href = signicatAuthUrl;
    });


    recalculateLink.addEventListener('click', () => {
        var newURL = window.location.href.split('?')[0]
        window.history.pushState({}, null, newURL);
        resetFields();
        hideOrgSetUnableString();
        signicatCallbackUrl = window.location.href + "?m2";
    });

    submitAttachment.addEventListener('change', () => {
        attachmentErrorOutput.style.display = 'none';
        //uploadedFiles
        submitAttachment.files.length > 0
            ? attachmentList.style.display = 'block'
            : attachmentList.style.display = 'none';

        if (submitAttachment.files) {
            const files = Array.from(submitAttachment.files); // Convert FileList to array
            uploadedFiles = uploadedFiles.concat(files);
        }
        updateAttachmentList();
    });

    function removeFileElement(index: number) {
        if (index >= 0 && index < uploadedFiles.length) {
            // Remove the file from the uploadedFiles array
            uploadedFiles.splice(index, 1);

            // Update the attachment list display
            updateAttachmentList();
        }
    }

    function updateAttachmentList() {
        if (!attachmentList || !uploadedFiles) {
            return
        }

        attachmentList.innerHTML = "";

        Array.from(uploadedFiles).forEach((file, index) => {
            const listItem = document.createElement('li'); // Create a new list item
            const textElement = document.createElement('span'); // Create a new span element
            textElement.textContent = file.name; // Set the text content to the file name
            textElement.className = 'attachmentName';
            listItem.className = 'listIcon';

            const anchorElement = document.createElement('a');
            anchorElement.href = '#';
            anchorElement.className = 'attachmentLink';
            anchorElement.textContent = 'Fjern';
            anchorElement.addEventListener('click', (event) => {
                event.preventDefault();
                removeFileElement(index); // Call removeMe with the index
            });
            listItem.appendChild(textElement);
            listItem.appendChild(anchorElement);
            attachmentList.appendChild(listItem);
        });

        updateAttachmentListDisplay();
    }

    function updateAttachmentListDisplay() {
        if (attachmentList && attachmentList.children.length === 0) {
            attachmentList.style.display = 'none';
        }
    }


    submitButton.addEventListener('click', async () => {
        if (!await validateForm()) {
            return
        }
        submitData();
    });

    function resetFields() {
        m2.value = "";
        gate.value = "";
        gateNummer.value = "";
        postnr.value = "";
        poststed.value = "";
    }

    function hideOrgSetUnableString() {
        furtherInputFields.style.display = 'none';
        priceCalcluatorparent.style.display = 'block';
        estimatedPrice = unableString;
        orgNumber.value = "";
        orgName.value = "";
    }

    async function submitData() {
        if (submitAttachment !== undefined && uploadedFiles.length > 0) {
            const token = await getToken("dynamics");
            for (var i = 0; i < uploadedFiles.length; i++) {
                await uploadFile(uploadedFiles[i], token);
            }
        }

        if (!fileUploadFailed) {
            await quoteRequest();
        }
    }

    async function uploadFile(file: File, token: string) {
        try {

            const myHeaders = new Headers();

            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", 'application/json');

            const requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                body: file
            };

            const url = `${uploadAttachmentUrl.value}/${file.name}`;
            const response = await fetch(url, requestOptions);

            if (!response.ok) {
                fileUploadFailed = true;
                throw new Error(response.statusText);
            }

            let fileRef = <FileReference>{};
            fileRef.FileName = file.name;
            fileRef.FileType = file.type;
            fileRef.FileRef = response.headers.get('fileref');

            fileReferences.push(fileRef);

            fileUploadFailed = false;
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error uploading file:', error);
            attachmentErrorOutput.innerHTML = error.message;
            attachmentErrorOutput.style.display = 'block';
            return;
        }
    }

    async function quoteRequest() {
        try {
            const [firstname, lastname] = firstName.value.split(" ");
            decodeParams();

            const submissionData: any = {
                "Type": decodedParams.get('who'),
                "Firstname": firstname || '',
                "Lastname": lastname || '',
                "Street": decodedParams.get('gate'),
                "PostalCode": decodedParams.get('postnr'),
                "Email": email.value,
                "Phone": phoneNumber.value,
                "M2": parseFloat(decodedParams.get('m2') || '0')
            };

            if (description.value !== "") {
                submissionData.Comments = description.value;
            }

            decodedParams.get('estimat') === unableString
                ? submissionData.PriceEstimate = null
                : submissionData.PriceEstimate = decodedParams.get('estimat');

            if (fileReferences.length > 0) {
                submissionData.FileRefrences = fileReferences;
            }

            if (orgNumber.value !== "" && orgName.value !== "") {
                submissionData.OrganizationNumber = orgNumber.value;
                submissionData.CompanyName = orgName.value
            }
            const token = await getToken("dynamics");
            const myHeaders = new Headers();

            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", 'application/json');

            const jsonData = JSON.stringify(submissionData);

            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: jsonData
            };

            const response = await fetch(quoteRequestUrl.value, requestOptions);

            if (!response.ok) {
                const message = await response.text();
                throw new Error(message);
            }
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error submitting quote:', error);
            quoteRequestErrorOutput.innerHTML = error.message;
            quoteRequestErrorOutput.style.display = 'block';
            return;
        }

        furtherInputFields.style.display = 'none';
        receipt.style.display = 'block';

        var newURL = window.location.href.split('?')[0]
        window.history.pushState({}, null, newURL);

        let dims = asphaltCalculator.getBoundingClientRect();
        window.scrollTo(window.scrollX, dims.top - 95 + window.scrollY);;
    }
});